import RightColumn from "./RightColumn";

export default RightColumn;
export {
    RightColumn
};